import React, { SetStateAction } from 'react';
import LogInTooltip from './LogInTooltip';
import { styles } from './WishlistTooltip.css';

export type WishlistTooltipProps = {
  productCartData?: any;
  sku?: number;
  isDigital?: boolean;
  priceTagWidth?: number;
  tooltipVisible?: boolean;
  displayLoginModal?: boolean;
  tooltipMessage?: string;
  variantId?: number;
  isLoggedIn?: boolean;
  setDisplayLoginModal?: React.Dispatch<SetStateAction<boolean>>;
  setToolTipVisible?: React.Dispatch<SetStateAction<boolean>>;
};
export const WishlistTooltip = ({
  productCartData,
  sku,
  isDigital,
  priceTagWidth,
  tooltipVisible,
  displayLoginModal,
  tooltipMessage,
  variantId,
  isLoggedIn,
  setDisplayLoginModal,
  setToolTipVisible,
}: WishlistTooltipProps): JSX.Element => {
  const objectId: number = productCartData?.Id;
  const toolTipWidth =
    priceTagWidth && !isLoggedIn ? priceTagWidth : priceTagWidth && isLoggedIn ? 'fit-content' : 'auto';

  return displayLoginModal ? (
    <LogInTooltip
      productCartData={productCartData}
      sku={sku}
      isDigital={isDigital}
      priceTagWidth={priceTagWidth}
      tooltipVisible={tooltipVisible}
      displayLoginModal={displayLoginModal}
      tooltipMessage={tooltipMessage}
      variantId={variantId}
      className={styles.loginModalFade({ displayLoginModal })}
      setDisplayLoginModal={setDisplayLoginModal}
      setToolTipVisible={setToolTipVisible}
    />
  ) : (
    <span
      className={`tool-tip ${styles.toolTip({ tooltipVisible })}`}
      style={{
        width: toolTipWidth,
      }}
      data-product-sku={sku}
      data-product-objectid={objectId}
    >
      {tooltipMessage}
    </span>
  );
};
export default WishlistTooltip;
